import React from "react";
import styles from "./ContainerHeader.module.css";
import Tooltip from "../../Tooltip/Tooltip";

const ContainerHeader = ({ title, links }) => (
  <div className={styles.header}>
    <h1 className={styles.title}>{title}</h1>
    {links.map(({href, onClick, icon, text, tooltip}, index) => (href || onClick) && (icon || text) && (
      <Tooltip label={tooltip}>
        <a key={index} href={href || '#'} onClick={onClick}>
          {icon ? (
            <i className={`${icon} ${styles.icon}`}></i>
          ): (
            {text}
          )}
        </a>
      </Tooltip>
    ))}
  </div>
)

export default ContainerHeader;



// WEBPACK FOOTER //
// ./src/components/Container/ContainerHeader/ContainerHeader.js